<template>
    <modal size="lg" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title" v-if="deduction">Edit Benefit Deduction</h3>
            <h3 class="modal-title" v-else>Add Benefit Deduction</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Employee: </span>{{ employee.full_name }}</div>
                    <div><span class="text-muted">Company: </span>{{ employee.company.name }}</div>
                </div>
            </div>

            <div class="form-row">
                <div class="col col-4">
                    <h5 class="table-header-like">Deduction</h5>
                    <div v-if="deduction" class="pt-hf">
                        {{ deduction.company_deduction_type.name }}
                    </div>
                    <form-input v-else class="grid-input" v-model="formData.company_deduction_type" :errors="errors.company_deduction_type" type="select" :options="deductionTypeOptions"/>
                </div>
                <div class="col col-2">
                    <h5 class="table-header-like">Amount</h5>
                    <form-input class="grid-input" v-model="formData.amount" :errors="errors.amount" type="currency"/>
                    <p class="field-helper-text">per month</p>
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'employee', 'deduction', 'clientDeductionTypes', ],
    mixins: [FormMixin, ModalMixin],
    components: {},
    emits: ['updated', 'close', ],
    data() {
        const data = {
            formData: this.makeFormData(),
            formRules: {
                company_deduction_type: {presence: {allowEmpty: false}},
                amount: {presence: {allowEmpty: false}},
            },
            formLabels: {
            },
        }

        return data
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.employee.company_id)
        },
        deductionTypeOptions() {
            const result = []

            // Keyed on the CompanyDeductionType, not the global type: a company may hold
            // several of one type, and the employee can be enrolled in each of them.
            let existingIds = this.employee.other_benefit_deductions.filter(d => d.is_active).map(d => d.company_deduction_type_id)

            let cets = this.clientDeductionTypes.filter(cet => cet.company_id == this.employee.company_id && !existingIds.includes(cet.id))
            // TODO KB ES if non-admin, further filter based on employee.position.deduction_types
            cets.forEach(cet => {
                // NB: the value is the CompanyDeductionType id, not the global DeductionType id
                result.push({text: cet.name, value: cet.id})
            })

            result.sort((a, b) => a.text > b.text ? 1 : -1)

            return result
        },
    },
    methods: {
        makeFormData() {
            const data = {
                company_deduction_type: this.deduction?.company_deduction_type_id ? this.deduction.company_deduction_type_id : '',
                amount: this.deduction ? this.deduction.amount : '',
            }

            return data
        },
        getFormRules() {
            const rules = JSON.parse(JSON.stringify(this.formRules))

            if (!this.deduction) {
                rules.company_deduction_type = {presence: {allowEmpty: false}, }
            }
            return rules
        },
        validate() {
            let isValid = FormMixin.methods.validate.call(this)

            return isValid
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            const data = this.getFormData()

            let url
            if (this.deduction) {
                url = `/clients/${this.client.id}/employees/${this.employee.id}/other-benefit-deductions/${this.deduction.id}`
            } else {
                url = `/clients/${this.client.id}/employees/${this.employee.id}/other-benefit-deductions`
            }
            this.$store.dispatch('START_LOADING')
            return this.$api.post(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved deduction.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
